<template>
  <!-- 质量检测 -->
  <div class="inspection">
    <div class="inspection-photo">
      <span></span>
      <div class="photo-title">{{$t('design.orderDetail.screenshotInfo') || "截图信息"}}</div>
    </div>
    <div class="screenshot-box">
      <xl-scrollbar>
        <div v-if="srcList?.length">
          <div v-for="(img, index) in srcList" :key="index" class="img-block">
            <xl-image
              :src="img.url"
              fit="contain"
              :preview-src-list="srcList"
              :initial-index="index"
            />
            <xl-tooltip :content="img.filename" placement="top">
              <div class="img-name">{{ img.filename }}</div>
            </xl-tooltip>
          </div>
        </div>
        <div v-else class='no-data-box'>
          <noData></noData>
        </div>
      </xl-scrollbar>
    </div>
  </div>
</template>
<script setup>
import { XlImage, XlScrollbar, XlTooltip } from "@shining3d/ui-components";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $getCdnUrl } from '../../../utils/common.js';
import { onMounted, ref, watch } from 'vue';
import noData from '../../../components/no-data.vue'

const props = defineProps({
  qualityFiles: {
    type: Array
  }
})
const { $t } = useLang("@shining3d/xl-design-order");
const srcList = ref([])

watch(()=>props.qualityFiles, (val)=>{
  srcList.value = val?.map((item) => ({
    url: $getCdnUrl({bucket: item?.bucket, dfsID: item?.dfsID}),
    filename: item?.fileName
  }))
},{ immediate: true, deep: true })
</script>
<style lang="scss" scoped>
.inspection {
  padding: 16px;
  height: calc(100% - 32px);
  font-family: "Alibaba PuHuiTi 2.0";
  .inspection-photo {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    height: 26px;
    span {
      width: 5px;
      height: 16px;
      background: #5587ff;
      margin-right: 8px;
    }
    .photo-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 22.4px;
      color: #2c364e;
    }
  }
  .screenshot-box {
    height: 100%;
    .img-block {
      display: inline-block;
      margin: 8px 16px 8px 0;
      &:last-child {
        margin-right: 0 !important;
      }
      :deep(.el-image__preview){
        width: 245px;
        height: 146.38px;
        border-radius: 4px;
        border: 1px solid #E0E4EA;
        box-sizing: border-box;
      }
      &:hover{
        :deep(.el-image__preview){
          border: 1px solid #5587FF !important;
        }
        .img-name{
          color: #5587FF !important;
        }
      }
    }
    .img-name {
      max-width: 243px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #737e99;
    }
  }
  :deep(.el-image__preview) {
    width: 243px;
  }
  :deep(.el-scrollbar__wrap){
   height: calc(100% - 32px);
  }
  :deep(.el-image-viewer__canvas) {
    img {
      min-width: 800px;
    }
  }
  :deep(.el-scrollbar__view){
    height: 100%;
  }
  .no-data-box{
    height: 100%;
  }
}
</style>
